export const environment = {
  production: true,
  apiURL: 'productionApi',
  backendApi: 'https://vpmt-rc23342883231ksh.azurewebsites.net/api/'
};
